import React, { useRef, memo, useEffect, useState, useCallback  } from 'react'
import { Alert, Table } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import MediaQuery from 'react-responsive'
import PositionItem from './PositionItem.jsx'

const PositionList = memo(
  ({
    positions,
    setPositions,
    formErrors,
    resetErrorByFormKey,
  }) => {
    const [nextFocus, setNextFocus] = useState(null)
    const ref = useRef()
    const handleNextFocus = (id, name) => {
      let nextFocusParam = {
        id: id,
        name: name,
      }
      setNextFocus(nextFocusParam)
    }
    const focusInput = useCallback(() => {
      let id = nextFocus.id
      //let name = nextFocus.name
      const allTagInputs = document.getElementsByTagName('input') //=>allInputs is a HTMLCollection not an Array!!!
      let allNameInputs = []
      for (let i = 0; i < allTagInputs.length; i++) {
        if (!allTagInputs[i].disabled) {
            if (allTagInputs[i].id.includes(`qc_`)) {
              allNameInputs.push(allTagInputs[i])
            }
        }
      }
      let foundIndex = allNameInputs.findIndex((item) => item.id === id)
      let nextfield =
        foundIndex >= 0 && allNameInputs[foundIndex + 1]
          ? allNameInputs[foundIndex + 1]
          : allNameInputs[0]
      // If found, focus the next field
      if (nextfield) {
        nextfield.focus()
      }
      setNextFocus(null)
    }, [nextFocus])
    const handleChangePositionByKey = (id, key, value) => {
      let index = positions.findIndex((item) => item.id === id)
      if (index >= 0) {
        const newPosistions = [...positions]
        switch (key) {
          /*case 'articleVariant':
            newPosistions[index].articleVariant = { id: value }
            break*/
          case 'quantityCounted':
            newPosistions[index][key] = parseInt(value)
            break
          default:
            newPosistions[index][key] = value
            break
        }
        setPositions(newPosistions)
      }
    }
    const renderPosition = (position, index, enforceListView) => {
      return (
        <PositionItem
          key={position.id}
          position={position}
          handleChangePositionByKey={handleChangePositionByKey}
          enforceListView={enforceListView}
          index={index}
          formErrors={formErrors}
          resetErrorByFormKey={resetErrorByFormKey}
          handleNextFocus={handleNextFocus}
        />
      )
    }
    const { t } = useTranslation()
    const enforceListView = positions.some(
      (item) => !!item.article.useSerialKeys || !!item.article.useBatchKeys
    )
    useEffect(() => {
      if (nextFocus) {
        const timer = setTimeout(() => {
          focusInput()
        }, 20)
        return () => clearTimeout(timer)
      }
    }, [nextFocus, focusInput])
    return (
      <div ref={ref}>
        <h1>{t('goodsReceiptOverlayProgress:positions')}</h1>
        <div className='spacing-down'>
          {positions.length === 0 && (
            <Alert variant='info'>{t('goodsReceiptPage:noPositions')}</Alert>
          )}
          {!!formErrors['positions'] && (
            <Alert variant='danger'>{formErrors['positions']}</Alert>
          )}
          {!!enforceListView ? (
            positions.map((item, index) =>
              renderPosition(item, index, enforceListView)
            )
          ) : (
            <>
              {
                <MediaQuery maxWidth={998}>
                  {positions.map((item, index) =>
                    renderPosition(item, index, enforceListView)
                  )}
                </MediaQuery>
              }
              {!!positions.length && (
                <MediaQuery minWidth={999}>
                  <Table borderless>
                    <tbody>
                      <tr>
                        <th>{t('productDetail:articleNumber')}</th>
                        <th>{t('productDetail:articleDescription')}</th>
                        <th>{t('size')}</th>
                        <th>{t('goodsReceiptPage:quantityExpected')}</th>
                        <th>{t('picking:quantityOnStock')}</th>
                      </tr>
                      {positions.map((item, index) =>
                        renderPosition(item, index, enforceListView)
                      )}
                    </tbody>
                  </Table>
                </MediaQuery>
              )}
            </>
          )}
        </div>
      </div>
    )
  }
)

export default PositionList
